var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66668 23.8333H17.3333C21.6883 23.8333 22.4683 22.0892 22.6958 19.9658L23.5083 11.2992C23.8008 8.65583 23.0425 6.5 18.4167 6.5H7.58335C2.95752 6.5 2.19918 8.65583 2.49168 11.2992L3.30418 19.9658C3.53168 22.0892 4.31168 23.8333 8.66668 23.8333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 6.49999V5.63332C8.66669 3.71582 8.66669 2.16666 12.1334 2.16666H13.8667C17.3334 2.16666 17.3334 3.71582 17.3334 5.63332V6.49999",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 14.0833V15.1667C15.1666 15.1775 15.1666 15.1775 15.1666 15.1883C15.1666 16.3692 15.1558 17.3333 13 17.3333C10.855 17.3333 10.8333 16.38 10.8333 15.1992V14.0833C10.8333 13 10.8333 13 11.9166 13H14.0833C15.1666 13 15.1666 13 15.1666 14.0833Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4542 11.9167C20.9517 13.7367 18.0917 14.82 15.1667 15.1883",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83832 12.2092C5.27582 13.8775 8.02748 14.885 10.8333 15.1992",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.dcff672d9647f381138a804530ebd620.svg";
export { ForwardRef as ReactComponent };